export default "__VITE_ASSET__sYQMwkeO__"